/**
 * vuex状态管理
 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    lang: localStorage.getItem('hippoWebLang') ? localStorage.getItem('hippoWebLang'): 'en',
    isSelectLang: localStorage.getItem('isSelectLang') ? localStorage.getItem('isSelectLang'): false,
  },
  mutations: {
    SET_LANGUAGE(state, lang) {
      state.lang = lang;
      localStorage.setItem('hippoWebLang', lang); // 本地化
    },
    SET_IS_SELECT_LANG(state, status) {
      state.isSelectLang = status; // 更新语言选择状态
      localStorage.setItem('isSelectLang', status);  
    }
  },
  actions: {},
  modules: {}
});
